import {createSelector} from 'reselect';

import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {getLocalApplications} from '../../data/localApplications/localApplicationsSelectors';
import {getFlatPanels} from '../panelsSelectors';
import {panelIsSettingsPanel} from '../panelsState';
import {
  isSettingsResourcesCustomFieldsResource,
  isSettingsResourcesDevelopersResource,
} from './settingsPanelState';

export const getSettingsPanel = createSelector(getFlatPanels, (panels) => {
  const panel = panels.find(panelIsSettingsPanel);
  if (!panel) {
    return undefined;
  }

  return panel;
});

export const getSettingsPanelResources = createSelector(
  [getSettingsPanel],
  (settingsPanel) => settingsPanel?.resources,
);

export function makeGetSettingsResourcesSelectedCustomFieldIds() {
  return createSelector([getSettingsPanelResources], (settingsResources) => {
    if (!settingsResources || !isSettingsResourcesCustomFieldsResource(settingsResources)) {
      return [];
    }
    return settingsResources.selectedCustomFieldIds ?? [];
  });
}

export const getIsSettingsLocalApplicationsLoading = createSelector(
  [getSettingsPanelResources],
  (resources) => {
    if (resources && isSettingsResourcesDevelopersResource(resources)) {
      return Boolean(
        !resources.localApplicationsAsyncStatus ||
          resources.localApplicationsAsyncStatus === AsyncStatusesEnum.LOADING,
      );
    }
    return false;
  },
);

export const getIsSettingsLocalApplicationLoading = createSelector(
  [getSettingsPanelResources, getLocalApplications],
  (resources, localApplications) => {
    if (resources && isSettingsResourcesDevelopersResource(resources)) {
      // If we already have the local application in the store we can treat it as if we are not loading.
      if (resources.localApplicationId && localApplications[resources.localApplicationId]) {
        return false;
      }
      return Boolean(
        !resources.localApplicationAsyncStatus ||
          resources.localApplicationAsyncStatus === AsyncStatusesEnum.LOADING,
      );
    }
    return false;
  },
);

export const getIsSettingsLocalApplicationAsyncStatus = createSelector(
  [getSettingsPanelResources],
  (resources) => {
    if (resources && isSettingsResourcesDevelopersResource(resources)) {
      return resources.localApplicationAsyncStatus;
    }
    return undefined;
  },
);

export const getIsSettingsTokensLoading = createSelector([getSettingsPanelResources], (resources) => {
  if (resources && isSettingsResourcesDevelopersResource(resources)) {
    return Boolean(
      !resources.apiTokenAsyncStatus || resources.apiTokenAsyncStatus === AsyncStatusesEnum.LOADING,
    );
  }
  return false;
});

export const getSettingsTokensAsyncStatus = createSelector([getSettingsPanelResources], (resources) => {
  if (resources && isSettingsResourcesDevelopersResource(resources)) {
    return resources.apiTokenAsyncStatus ?? AsyncStatusesEnum.LOADING;
  }
  return AsyncStatusesEnum.LOADING;
});
